import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useModal } from './ModalContext';
import PrimaryButton from 'components/buttons/PrimaryButton';
import SecondaryButton from 'components/buttons/SecondaryButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import '../../style/scss/modals.scss';

interface WarningModalProps {
    type?: 'info' | 'warning';
    header: string,
    message: string;
    messageValues?: Record<string, string>;
    icon?: IconDefinition;
    buttonLabel: string;
    onApproval?: () => void;
}

const WarningModal: React.FC<WarningModalProps> = ({
    type = 'warning',
    header,
    message,
    messageValues,
    icon,
    buttonLabel,
    onApproval
}) => {
    const { t } = useTranslation();
    const { revealModal, closeModal } = useModal();

    // Reveal the modal on first render
    useEffect(() => {
        revealModal();
    }, []);

    // Handle the delete
    const handleApproval = async () => {
        // Execute approval callback
        if (onApproval) {
            onApproval();
        }

        // Close the modal
        closeModal();
    };

    return (
        <div className='warning-modal'>
            {type === 'warning' ? (
                <div className='warning-icon'>
                    <FontAwesomeIcon 
                        icon={faTriangleExclamation} 
                    />
                </div>
            ) : (
                icon && (
                    <div className='alert-icon'>
                        <FontAwesomeIcon icon={icon} />
                    </div>
                )
            )}
            <h3 className='header text-center'>
                {t(header)}
            </h3>
            <p className='text-center'>
                {t(message, messageValues)}
            </p>
            <div className='button-row'>
                <SecondaryButton
                    onClick={() => closeModal()}
                    label='general.cancel'
                    size="small"
                />
                <PrimaryButton
                    onClick={() => handleApproval()}
                    label={buttonLabel}
                    customClass={type === 'warning' ? 'warning' : ''}
                    size="small"
                />
            </div>
        </div>
    )
}

export default WarningModal;